import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { DEFAULT_DISPLAY_SETTING } from "../lib/ConstList";
import { API, graphqlOperation } from 'aws-amplify';
import {
  onCreateTrendGraph,
  onUpdateTrendGraph,
} from '../graphql/subscriptions';
import { trendGraphsByTypeAndCreatedAt } from '../graphql/queries';
import {
  getDisplaySettingJson,
} from '../lib/SettingUtil';

import {
  Flex,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Button,
} from "@aws-amplify/ui-react";

const Row = ({ row, displaySettingJson }) => {

  const date = useMemo(() => {
    const date = new Date(row.createdAt);
    return date.toLocaleDateString() + " " + date.toLocaleTimeString();
  }, [row.createdAt]);

  const locationName = useMemo(() => {
    const location = displaySettingJson.location_name[row.location_name];
    return location;
  }, [row.location_name, displaySettingJson]);

  const band = useMemo(() => {
    const band = displaySettingJson.band_label[row.band];
    return band.name;
  }, [row.band, displaySettingJson]);

  const period = useMemo(() => {
    // 2025-02 -> 2025/02
    const start = row.start_at.replace(/-/g, "/");
    const end = row.end_at.replace(/-/g, "/");
    return start + " ~ " + end;
  }, [row.start_at, row.end_at]);

  const status = useMemo(() => {
    switch (row.status) {
      case "pending":
        return "生成中";
      case "done":
        return "完了";
      case "error":
        return "エラー";
      default:
        return "";
    }
  }, [row.status]);

  return (
    <TableRow>
      <TableCell>{date}</TableCell>
      <TableCell>{locationName}</TableCell>
      <TableCell>{band}</TableCell>
      <TableCell>{period}</TableCell>
      <TableCell>
        <Button
          size="small"
          variation="link"
          padding="5px"
          isDisabled={row.status !== "done"}
          onClick={() => {
            if (row.status !== "done") {
              return;
            }

            if (row.path === null) {
              return;
            }

            // pathを取得 先頭のpublic/を削除
            const path = row.path.replace("public/", "");

            const url = `/datakanri?path=${path}`;

            // 別タブでtrendを表示
            window.open(url, "_blank");
          }}
        >
          {
            row.status === "done" ? "リンク" : status
          }
        </Button>
      </TableCell>
    </TableRow>
  );
}

const TrendGraphList = ({
}) => {
  // 表示ラベル設定
  const [displaySettingJson, setDisplaySettingJson] = useState(DEFAULT_DISPLAY_SETTING);

  const [list, setList] = useState([]);
  const onCreateSubscribe = useRef(null);
  const onUpdateSubscribe = useRef(null);

  const getTrendGraphList = async () => {
    const trendGraphList = await API.graphql(graphqlOperation(trendGraphsByTypeAndCreatedAt, {
      type: "trendGraph",
      sortDirection: "DESC",
      limit: 100,
    }));
    console.debug(trendGraphList);

    setList(trendGraphList.data.trendGraphsByTypeAndCreatedAt.items);
  }

  const startSubscribe = async () => {
    // サブスクリプションを登録
    onCreateSubscribe.current = API.graphql(graphqlOperation(onCreateTrendGraph)).subscribe({
      next: (data) => {
        console.log("onCreateTrendGraph", data);
        // ログデータを取得
        const trendGraph = data.value.data.onCreateTrendGraph;

        // すでに存在する場合
        const exists = list.some((item) => item.id === trendGraph.id);

        if (!exists) {
          setList((prevList) => {
            const updateLogList = [...prevList];
            console.warn("updateLogList", updateLogList);

            // ログデータを追加
            updateLogList.push(trendGraph);
            console.warn("updateLogList", updateLogList);

            // ソート
            updateLogList.sort((a, b) => {
              return new Date(b.createdAt) - new Date(a.createdAt);
            });

            console.warn("updateLogList", updateLogList);

            // 100件以上の場合は削除
            if (updateLogList.length > 100) {
              updateLogList.splice(100, updateLogList.length - 100);
            }

            return updateLogList;
          });
        }
      },
      error: (error) => {
        console.log(error);
      }
    });

    // サブスクリプションを登録
    onUpdateSubscribe.current = API.graphql(graphqlOperation(onUpdateTrendGraph)).subscribe({
      next: (data) => {
        console.log("onUpdateTrendGraph", data);

        // ログデータを取得
        const trendGraph = data.value.data.onUpdateTrendGraph;

        setList((prevList) => {
          // すでに存在する場合
          const exists = prevList.some((item) => item.id === trendGraph.id);

          if (exists) {
            const updateLogList = [...prevList];

            // ログデータを更新
            const index = updateLogList.findIndex((item) => item.id === trendGraph.id);
            updateLogList[index] = trendGraph;

            return updateLogList;
          }
        });
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  const stopSubscribe = async () => {
    // サブスクリプションを解除
    if (onCreateSubscribe.current) {
      onCreateSubscribe.current.unsubscribe();
      onCreateSubscribe.current = null;
    }

    // サブスクリプションを解除
    if (onUpdateSubscribe.current) {
      onUpdateSubscribe.current.unsubscribe();
      onUpdateSubscribe.current = null;
    }
  }

  // 表示設定取得
  const initDisplaySettingJson = useCallback(async () => {
    const displaySettingJson = await getDisplaySettingJson();
    if (displaySettingJson !== null) {
      setDisplaySettingJson(displaySettingJson);
    } else {
      console.log("displaySettingJson is null");
    }
  }, []);

  useEffect(() => {
    getTrendGraphList();

    // 表示設定取得
    initDisplaySettingJson();

    // サブスクリプション開始
    startSubscribe();

    // クリーンアップ
    return () => {
      stopSubscribe();
    }
  }, []);

  return (
    <>
      <Flex
        direction="column"
        padding="70px 40px 40px 0px"
      >
        <Flex>
          履歴

          <span
            style={{
              marginLeft: "auto",
              fontSize: "0.8rem",
              color: "#888",
            }}
          >
            直近100件
          </span>
        </Flex>

        <Flex
          maxHeight="24rem"
          overflow="auto"
        >
          <Table
            width="35rem"
            caption=""
            size="small"
            highlightOnHover={false}
          >
            <TableHead>
              <TableRow
                position="sticky"
                top={0}
                backgroundColor="rgb(222, 222, 222)"
                borderColapse="separate"
              >
                <TableCell as="th">生成日時</TableCell>
                <TableCell as="th">拠点</TableCell>
                <TableCell as="th">スロット</TableCell>
                <TableCell as="th">期間</TableCell>
                <TableCell as="th"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                list.map((trendGraph) => (
                  <Row
                    key={trendGraph.id}
                    row={trendGraph}
                    displaySettingJson={displaySettingJson}
                  />
                ))
              }
            </TableBody>
          </Table>
        </Flex>
      </Flex>
    </>
  );
}

export default TrendGraphList;